/*

Allgemeines modales Fenster mit Shader, Header mit Titel und Schließen-Button, Footer mit Filtern und OK-Button

 _________________________
| Fenstertitel          X |
|_________________________|
|                         |
|                         |
|        Inhalt           |
|                         |
|_________________________|
| Filter           [ OK ] |
|_________________________|

*/

import {Trans, t} from "@lingui/macro";
import './Modal.css'
import {type} from "@testing-library/user-event/dist/type";

function Modal({id, title, filters, notes, onClose, onFilterChange, children}) {

    function closeHandler() {
        onClose()
    }

    function stopPropagationToShader(e) {
        e.stopPropagation()
    }

    return (
        <div className='modalShader' onClick={closeHandler}>
            <div className="modal" onClick={stopPropagationToShader}>

                <header>
                    <div className="title">{title}</div>
                    <button className="closeModal" onClick={closeHandler}></button>
                    <button className="btnPrimary ok" onClick={closeHandler}><Trans>OK</Trans></button>
                </header>

                <main>

                    {notes ?
                        <>
                            {notes.map((note, i) => (
                                <div key={i} className='info'><i className="fas fa-exclamation-circle"></i>&nbsp; {note}</div>
                            ))}
                        </>
                        :
                        ''
                    }

                    {children}
                </main>

                <footer>
                    {(typeof filters !== 'undefined') ? <span className="text"><i className="far fa-filter"></i> &nbsp;<Trans>Optionen filtern:</Trans></span> : ''}
                    {(typeof filters !== 'undefined') ?
                        <span className="filters">
                            {filters.map((filter, i) => (
                                <span key={i}>
                                    {filter.options.length > 1 ?
                                        <select className='filter' name={filter.id} onChange={e => onFilterChange(e.target.name, e.target.value)}>
                                            <option value="">{t({message: filter.name})}: (<Trans>alle</Trans>)</option>
                                            {filter.options.map((option, j) => (
                                                (Array.isArray(option) ?
                                                    <option value={option[0]} key={j}>{t({message: filter.name})}: {option[1]}</option>
                                                :
                                                    <option value={option} key={j}>{t({message: filter.name})}: {option}</option>
                                                )

                                            ))}
                                        </select>
                                    :
                                        <label className='filter'><input type='checkbox' name={filter.id} onChange={e => onFilterChange(e.target.name, e.target.checked)} /> {filter.name}</label>
                                    }
                                </span>
                            ))}
                        </span>
                    : '' }
                    <button className="btnPrimary ok" onClick={closeHandler}><Trans>OK</Trans></button>
                </footer>

            </div>
        </div>
    )

}

export default Modal
